import { useState } from 'react'
import ArpRegistry from '../../../../features/arp-registry/ArpRegistry'
import { useAsyncEffect } from '../../platform/explore/common/utils'

/**
 * Represents a single sample pack object. ARP media can be tagged with "sample-pack:name"
 * to have them be shown with this special UI.
 */
type SamplePack = {
  // Unique string identifier for this sample pack
  name: string
  // Parent project for this sample pack
  parentProject: string
  // Description of the pack
  description: string
}

export const SamplePacks: { [key: string]: SamplePack } = {
  // Heds Sample Pack 1.
  'hedsDAO Sample Pack': {
    name: 'hedsDAO Sample Pack',
    parentProject: 'hedsDAO',
    description:
      '"Heds are long time admirers of Arpeggi. Sample packs, mixtapes & collaboration are hallmarks of digital music culture and thus represent with where we come from. Both heds and Arpeggi have brought their take on creativity to the web3 world - this collection is an homage from one web3 entity to another."'
  }
}

interface MetaTags {
  [key: string]: string
}

/**
 * Parses out tags from the metadata of an arp media. These tags might contain
 * information about which project the media came from or which samplepack they belong to.
 *
 * TODO Move this processing into OCEL -- so client never has to directly access these tags.
 */
export const parseMetatags = async (tokenId: string | number, type: string) => {
  const media = await ArpRegistry.getByIdAsync(tokenId)
  const rawTags = media.metadata.tags

  const tags: string[] = []
  const meta: MetaTags = {}

  rawTags.forEach((rawTag) => {
    if (rawTag.includes(':')) {
      const [key, ...val] = rawTag.split(':')
      meta[key] = val.join(':')
      return
    }
    tags.push(rawTag)
  })

  return { tags, meta }
}

const useMetatagParser = (tokenId: string | number, type: string) => {
  const [tags, setTags] = useState<string[]>([])
  const [meta, setMeta] = useState<MetaTags>({})
  const status = useAsyncEffect(async () => {
    const { tags, meta } = await parseMetatags(tokenId, type)
    setTags(tags)
    setMeta(meta)
  }, [tokenId, type])
  return { tags, meta, status }
}

export default useMetatagParser
